import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.element.dataset.modalReady = "false"
    this.modal = window.bootstrap.Modal.getOrCreateInstance(this.element)
    this.modal.show()
  }

  shown() {
    const input = this.element.querySelector("[autofocus]")
    input?.focus()
    input?.setSelectionRange(input.value.length, input.value.length)
    this.element.dataset.modalReady = "true"
  }

  close() {
    this.removeWhenHidden = true
    this.modal.hide()
  }

  hidden() {
    this.element.dataset.modalReady = "false"
    if (!this.removeWhenHidden) return

    this.element.closest("turbo-frame")?.removeAttribute("src")
    this.element.remove()
  }

  disconnect() {
    this.modal?.dispose()
    document.querySelectorAll(".modal-backdrop").forEach((backdrop) => backdrop.remove())
    document.body.classList.remove("modal-open")
    document.body.style.removeProperty("overflow")
    document.body.style.removeProperty("padding-right")
  }
}
